var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('router-view'),_c('SnackbarCpt')],1),_c('CallToRegisterCpt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }